export const OverallConfidenceArrow = ({ color }: { color: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
    >
      <path
        d="M-0.000355526 8.96842L17.0055 8.96842M10.6544 16.1767L17.0055 8.96842L10.6414 1.27488"
        stroke={color}
        strokeWidth="4"
      />
    </svg>
  );
};
